import { useMemo } from 'react';
import { Mission, SpotData } from 'types/spot';
import spot from 'data/spot.json';

type MissionRelatedData = {
  mission: Mission;
  article: SpotData;
};

export function useMissionRelatedData(missionNo: number): MissionRelatedData {
  return useMemo(() => {
    const spotList: SpotData[] = spot as unknown as SpotData[];
    const article = spotList.find(item =>
      item.mission?.some(mission => mission.missionNo === missionNo)
    );
    const mission = article?.mission?.find(mission => mission.missionNo === missionNo);
    return { mission: mission as Mission, article: article as SpotData };
  }, [missionNo]);
}
